export default "__VITE_ASSET__DYwGXyup__"